
import { defineComponent } from 'vue'
import { useMeta } from 'vue-meta'

export default defineComponent({
  name: 'AppMeta',
  props: {
    title: {
      type: String,
      default: 'INXY Payments',
    },
  },
  setup(props) {
    useMeta({
      title: props.title,
      htmlAttrs: {
        lang: 'en',
        amp: true,
      },
    })
  },
})
